module.exports = __webpack_public_path__ + "img/csc_2.959e77fd.gif";